import { useEffect, type ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "./provider";

/**
 * Route guard for React Router data routers. Use as a layout route element:
 *
 *   { element: <RequireAuth />, children: [{ path: "/account", element: <Account/> }] }
 *
 * While loading, renders `fallback`. If unauthenticated, redirects to the
 * central login and preserves the current URL as returnTo.
 */
export function RequireAuth({ fallback = null }: { fallback?: ReactNode }) {
  const { status, login } = useAuth();

  useEffect(() => {
    // replace: true — swaps this guarded page out of history instead of
    // pushing login on top of it, so the back button can't land here again.
    if (status === "unauthenticated") login(undefined, { replace: true });
  }, [status, login]);

  if (status !== "authenticated") return <>{fallback}</>;
  return <Outlet />;
}
